import { render } from "./AssessOwnership.vue?vue&type=template&id=d40db776&scoped=true"
import script from "./AssessOwnership.vue?vue&type=script&lang=js"
export * from "./AssessOwnership.vue?vue&type=script&lang=js"

import "./AssessOwnership.vue?vue&type=style&index=0&id=d40db776&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d40db776"]])

export default __exports__